import { render } from "./document-list.vue?vue&type=template&id=3e2fe983"
import script from "./document-list.vue?vue&type=script&lang=js"
export * from "./document-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__